/** @format */

import React from 'react';
import Dropdown from 'src/ui/library/Dropdown';
import Button from 'src/ui/library/Button';
import MenuItem from '@material-ui/core/MenuItem';
import intl from 'react-intl-universal';

export default function CasesConsentStatusPres({ consentStatusId, statusList, onUpdate, handleConsentStatusChange, disableUpdate }) {
  return (
    <section className="cases-status cases-manager-status">
      <div className="status-title">{intl.get('cases.status.consentUpdate')}</div>
      <div className="status-action">
        <Dropdown
          id="caseManagerStatus"
          name="caseManagerStatus"
          label={intl.get('cases.status.consentStatus')}
          onChange={event => handleConsentStatusChange(event.target.value)}
          value={consentStatusId}
          className={'status-action-dropdown'}
          disableUnderline={true}>
          {statusList &&
            statusList.length &&
            statusList.map((item, index) => (
              <MenuItem key={index} value={item.consentStatusId}>
                {item.consentStatus}
              </MenuItem>
            ))}
        </Dropdown>
        <Button disabled={disableUpdate} styleType="secondary" className="status-action-button" onClick={onUpdate}>
          {intl.get('cases.details.buttons.update')}
        </Button>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/ui/features/Cases/presentational/CasesManagerConsentStatusPres.js